import React from 'react';
import { withRouter } from 'react-router-dom';
import {
    Modal,
    Button
} from 'react-bootstrap';

import Config from '../../Configs';
import Options from './Entity/Options';
import Parse from '../../Parse';
import ReceiptBillTemplates from './Entity/ReceptBill/Template';
import ItemTemplates from './Entity/Items/Template';
import SaleConsumptionTemplates from './Entity/SaleConsumption/Template';
import InventoryTemplates from './Entity/Inventory/Template';
import ClockInOutTemplates from './Entity/ClockInOut/Template';
import ConverConfigsTemplates from './Entity/Convert/Configs';
import Spinner from '../../components/UI/Spinner/Spinner';

import './OutletImport.css';
import ItemsImportSummary from './Detail/ItemsImportSummary';
import SaleConsumptionImportSummary from './Detail/SaleConsumptionImportSummary';
import ReceipBillsImportSummary from './Detail/ReceipBillsImportSummary';
import InventoryImportSummary from './Detail/InventoryImportSummary';
import ClockInOutImportSummary from './Detail/ClockInOutImportSummary';
import DicrepancyImportSummary from './Detail/DicrepancyImportSummary';
import DashboardImport from './Dashboard/DashboardImport';

class OutletImport extends React.PureComponent {
    
    state = {
        pivot: null,
        tab: -1,
        tables: [],
        editors: [],
        options: {},
        flexIdContainer: "#wdr-component",
        loading: false,
        show: false,
        viewType: 1
    }

    componentDidMount = () => {
        this.getTableConfigs();
    }

    customizeToolbar = (toolbar) => {
        let tabs = toolbar.getTabs(toolbar);

        toolbar.getTabs = () => {
            const type = this.props.match.params.type;
            let template = [];
            switch(type) {
                case "inventory":
                    template = InventoryTemplates(toolbar, (name, config) => {
                        let tables = [...this.state.tables];
                        const tab = this.state.tab;
                        tables[tab] = {
                            name: name,
                            configuation: config
                        }
                        this.setState({
                            name: name,
                            options: config,
                            tables: tables
                        })
                    });
                    break;
                case "clock_in_out":
                    template = ClockInOutTemplates(toolbar, (name, config) => {
                        let tables = [...this.state.tables];
                        const tab = this.state.tab;
                        tables[tab] = {
                            name: name,
                            configuation: config
                        }
                        this.setState({
                            name: name,
                            options: config,
                            tables: tables
                        })
                    })
                    break;
                case "sales_consumption":
                    template = SaleConsumptionTemplates(toolbar, (name, config) => {
                        let tables = [...this.state.tables];
                        const tab = this.state.tab;
                        tables[tab] = {
                            name: name,
                            configuation: config
                        }
                        this.setState({
                            name: name,
                            options: config,
                            tables: tables
                        })
                    })
                    break;
                case "receipt_bills":
                    template = ReceiptBillTemplates(toolbar, (name, config) => {
                        let tables = [...this.state.tables];
                        const tab = this.state.tab;
                        tables[tab] = {
                            name: name,
                            configuation: config
                        }
                        this.setState({
                            name: name,
                            options: config,
                            tables: tables
                        })
                    })
                    break;
                case "items":
                    template = ItemTemplates(toolbar, (name, config) => {
                        let tables = [...this.state.tables];
                        const tab = this.state.tab;
                        tables[tab] = {
                            name: name,
                            configuation: config
                        }
                        this.setState({
                            name: name,
                            options: config,
                            tables: tables
                        })
                    })
                    break;
                default:
                    template = [];
                    break;
            }
            // delete the first tab
            delete tabs[0];
            delete tabs[1];
            let saveConfig = tabs[2];
            delete tabs[2];
            saveConfig = {
                ...saveConfig,
                title: "Save Json"
            }
            tabs[3] = {
                ...tabs[3],
                menu: [
                    ...tabs[3].menu,
                    saveConfig
                ]
            }
            tabs.unshift({
                divider: true
            })
            tabs.unshift({
                id: "fm-tab-templates",
                title: "Templates",
                icon: toolbar.icons.open,
                menu: template
            });   
            return tabs;
        }
    } 

    fetchPivotTable = (options) => {
        const configuation = ConverConfigsTemplates.convertToAfterProgress(options, this.props.match.params.user);
        console.log(configuation);
        const flexIdContainer = this.state.flexIdContainer;
        if(!this.state.pivot) {
            const reports = {
                ...{
                    dataSource: {
                        type: "csv",
                        filename: `${Config.s3Url}/${this.props.match.params.user}/${this.props.match.params.file}`,
                    },
                }, 
                ...{
                    slice: configuation.slice || {}
                },
                ...{
                    options: configuation.options || {}
                },
                ...{
                    formats: configuation.formats || []
                }
                
            }
            this.setState({
                pivot: new window.Flexmonster({
                    container: flexIdContainer,
                    toolbar: true,
                    height: "650px",
                    global: {
                        options: {
                            "defaultDateType": "string",
                        }
                    },
                    beforetoolbarcreated: this.customizeToolbar,
                    reportchange: () => {
                        const report = this.state.pivot.getReport();
                        let options = report.options;
                        if(options === undefined) {
                            options = {}
                        }
                        if(options.viewType === undefined) {
                            options.viewType = "grid"
                        }
                        this.setState({
                            options: {
                                slice: report.slice,
                                options: options,
                                formats: report.formats
                            }
                        })
                    },
                    report: reports,
                    licenseKey: Config.licensePivot
                })
            })
        }
        else {
            const pivot = this.state.pivot;

            //Set Options to default params
            pivot.setOptions(Options);
            pivot.refresh();

            if(configuation.slice !== undefined) {
                pivot.runQuery(configuation.slice);
            }
            if(configuation.options !== undefined) {
                pivot.setOptions(configuation.options);
            }
            if(configuation.formats !== undefined) {
                const formats = [...configuation.formats];
                const formatsLength = formats.length;
                for(let i = 0; i < formatsLength; i++) {
                    pivot.setFormat(formats[i]);
                }
            }
            pivot.refresh();
        }
    }

    getTableConfigs = () => {
        this.setState({
            loading: true
        })
        const owner = this.props.match.params.user;
        const token = localStorage.getItem(`${owner}_token`, owner);
        const type = this.props.match.params.type;
        const TableConfig2 = Parse.Object.extend("tableConfig2");
        const tableConfig2Query = new Parse.Query(TableConfig2);
        tableConfig2Query.equalTo('owner', owner);
        tableConfig2Query.first({
            sessionToken: token
        }).then(results => {
            if(!results) {
                this.setState({
                    tables: [],
                    editors: [],
                    loading: false,
                    viewType: 0
                })
                return;
            }
            let tables = results.get(type);
            let editors = results.get(type + "_text" );
            let viewType = this.state.viewType;
            if(!tables) {
                tables = [];
                viewType = 0;
            }
            if(!editors) {
                editors = [];
            }
            const dashboard = tables.filter(table => {
                if(table.view === "dashboard") {
                    return true;
                }
                return false;
            })
            if(dashboard.length <= 0) {
                viewType = 0 
            }
            const tab = this.state.tab;
            if(tab <= 0) {
                this.setState({
                    tables: tables,
                    loading: false,
                    editors: editors,
                    viewType: viewType
                })
            }
            else {
                this.setState({
                    name: tables[this.state.tab].name || "Default",
                    options: tables[this.state.tab].configuation || {},
                    tables: tables,
                    editors: editors,
                    loading: false
                }, () => {
                    const options = {...this.state.options};
                    this.fetchPivotTable(options);
                });
            }
        });
    }

    setActiveTab = (current) => {
        const tab = this.state.tab;
        if(tab === current) {
            return "btn btn-primary active";
        }
        return "btn btn-default";
    }

    setActiveTabFlexmonsterViewMobile = (tab) => {
        if(tab >= 0) {
            return "col-md-12 col-lg-12 col-xs-12 ItemsContent tabFlexmonster";
        }
        return "col-md-12 col-lg-12 col-xs-12 ItemsContent";
    }

    changeTabSelectHandler = (value) => {
        const tables = [...this.state.tables];
        if(value === 'add') {
            this.addMoreTable();
            return;
        }
        if(value == '-1') {
            this.changeTabHandler(-1, "Summary", {})
            return;
        }
        const table = tables[value];
        if(table === undefined) {
            return;
        }
        this.changeTabHandler(value, table.name, table.configuation);
    }

    changeTabHandler = (tab, name, options) => {
        this.setState({
            tab: tab,
            name: name,
            options: options
        }, () => {
            if(tab >= 0) {
                this.fetchPivotTable(this.state.options);
            }
            else {
                this.setState({
                    pivot: null
                });
            }
        })
    }

    openModalHandler = () => {
        this.setState({
            show: true,
            pivot: null
        }, () => {
            const tab = this.state.tab;
            if(tab >= 0) {
                this.fetchPivotTable(this.state.options);
            }
            else {
                this.setState({
                    pivot: null
                });
            }
        })
    }

    handleClose = () => {
        this.setState({
            show: false,
            pivot: null
        }, () => {
            const tab = this.state.tab;
            if(tab >= 0) {
                this.fetchPivotTable(this.state.options);
            }
            else {
                this.setState({
                    pivot: null
                });
            }
        })
    }

    changeViewTypeHandler = (type) => {
        this.setState({
            viewType: type
        })
    }

    render() {
        const tables = [...this.state.tables];
        const editors = [...this.state.editors];
        const type = this.props.match.params.type;
        const viewType = this.state.viewType;
        let content = (
            <div className="box box-info">
                <div className="box-body">
                    <Spinner></Spinner>
                </div>
            </div>
        )
        if(!this.state.loading) {
            let contentSummaries = null;

            switch(type) {
                case 'receipt_bills':
                    contentSummaries = <ReceipBillsImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></ReceipBillsImportSummary>;
                    break;
                case 'items':
                    contentSummaries = <ItemsImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></ItemsImportSummary>;
                    break;
                case 'sales_consumption':
                    contentSummaries = <SaleConsumptionImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></SaleConsumptionImportSummary>;
                    break;
                case 'inventory':
                    contentSummaries = <InventoryImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></InventoryImportSummary>;
                    break;
                case 'clock_in_out':
                    contentSummaries = <ClockInOutImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></ClockInOutImportSummary>;
                    break;
                case 'discrepancy':
                    contentSummaries = <DicrepancyImportSummary file={`${Config.s3Url}/${this.props.match.params.user}/summaries-${this.props.match.params.file}.json`} ownerId={this.props.match.params.user}></DicrepancyImportSummary>;
                    break;
                default: 
                    contentSummaries = (
                        <div style={{
                            textAlign: 'center'
                        }}> 
                            <h3><b>No content for summary</b></h3>
                        </div>
                    )
                    break;
            }

            if(viewType === 1) {
                content = (
                    <DashboardImport tables={tables} editors={editors} type={type} file={`${Config.s3Url}/${this.props.match.params.user}/${this.props.match.params.file}`}></DashboardImport>
                );
            }
            else {
                content = (
                    <div className="box box-info">
                        <div className="box-body">
                            <div>
                                <div className="col-md-12 col-lg-12 col-xs-12 hidden-xs hidden-sm">
                                    <div className="btn-group">
                                        <a className={this.setActiveTab(-1)} onClick={() => this.changeTabHandler(-1, "Summary", {})}>Summary</a>
                                        {
                                            tables.map((value, key) => {
                                                return (
                                                    <a key={key} className={this.setActiveTab(key)} onClick={() => this.changeTabHandler(key, value.name, value.configuation)}>{value.name}</a>
                                                )
                                            }) 
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12 col-lg-12 col-xs-12 hidden-lg hidden-md">
                                    <div className="form-group">
                                        <select className="form-control" onChange={(event) => this.changeTabSelectHandler(event.target.value)} value={this.state.tab}>
                                            <option value="-1">Summary</option>
                                            {
                                                tables.map((value, key) => {
                                                    return (
                                                        <option key={key} 
                                                            value={key}
                                                        >
                                                            {value.name}
                                                        </option>
                                                    )
                                                }) 
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                {
                                    !this.state.show ? (
                                        <div className="col-md-12 col-lg-12 col-xs-12">
                                            <div className="form-group hidden-md hidden-lg">
                                                <button className="btn btn-primary form-control" onClick={this.openModalHandler}>View Fullscreen</button>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                <div className="clearfix"></div>
                                <br></br>
                                <div className={this.setActiveTabFlexmonsterViewMobile(this.state.tab)}>
                                {
                                    this.state.tab >= 0 ? (
                                        <div className="row flexmonsterRow">
                                            <div className="col-md-6 col-lg-6 col-xs-12">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" value={this.state.name} readOnly/>  
                                                </div>
                                            </div>
                                            <div className="clearfix"></div>
                                            <div className="col-md-12 col-lg-12 col-xs-12 flexmonsterView">
                                                <div id="wdr-component"></div>
                                            </div>
                                        </div>
                                    ) : contentSummaries
                                }
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <Modal size="full" show={this.state.show} onHide={this.handleClose}  aria-labelledby="example-modal-sizes-title-lg">
                                <Modal.Header closeButton>
                                    <Modal.Title  bsPrefix="modal-title h4 pull-left">{this.props.title}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="ItemsPopUp">
                                        {content}
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary pull-right" onClick={this.handleClose}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className="Items row">
                <div className="col-md-12 col-xs-12 col-lg-12">
                    <div className="btn-group viewType btn-full pull-right">
                        <button className={viewType === 1 ? "btn btn-primary btnTab" : "btn btn-default btnTab"} onClick={() => this.changeViewTypeHandler(1)}>Dashboard</button>
                        <button className={viewType === 0 ? "btn btn-primary btnTab" : "btn btn-default btnTab"} onClick={() => this.changeViewTypeHandler(0)}>Data</button>
                    </div>
                </div>
                <div className="col-md-12 col-xs-12 col-lg-12">
                    {!this.state.show ? content : null}
                </div>
            </div>
        );
    }
}

export default withRouter(  OutletImport );